export const pumpFunLink = "https://pump.fun/profile/Exotix";
export const XLink = "https://x.com/SolanaExotix";
export const telegramLink = "https://t.me/solanaexotix";
